import { SelectedSource, schSourceType } from '@aloft/toolkit-shared';

import { get, set } from 'lodash';

import { PropertyGridFieldName } from '../../../../components/PropertyGrid/types.ts';
import {
  CompPropertyDataState,
  PropertyDataSliceExtraReducer,
  SubjectPropertyDataState,
} from '../../../types.ts';
import { resolveFeatureGridFieldConflicts } from '../../actions/resolveFeatureGridFieldConflicts.ts';
import { getBumpedSyncState } from '../../utils/getBumpedSyncState.ts';

export const featureGridConflictedFieldsExtraReducers: PropertyDataSliceExtraReducer = (
  builder,
) => {
  builder.addCase(resolveFeatureGridFieldConflicts, (state, action) => {
    const fieldsByProperty = Object.values(action.payload)
      .filter((v) => !!v)
      .reduce<Record<string, PropertyGridFieldName[]>>((acc, { fieldName, propertyId }) => {
        (acc[propertyId] ??= []).push(fieldName);
        return acc;
      }, {});

    Object.entries(fieldsByProperty).forEach(([propertyId, fieldNames]) => {
      const current = state.entities[propertyId];
      if (!current) return;

      const propertyData =
        propertyId === 'subject'
          ? (current as SubjectPropertyDataState).subjectData
          : (current as CompPropertyDataState).compData;

      const selectedSources = propertyData.selectedSources ?? {};
      propertyData.selectedSources = selectedSources;

      fieldNames.forEach((fieldName) => {
        const selectedSourceField = get(selectedSources, fieldName) as SelectedSource | undefined;

        set(selectedSources, fieldName, {
          source: selectedSourceField?.source ?? schSourceType.enum.none,
          justification: selectedSourceField?.justification,
          conflictIsResolved: true,
        });
      });

      current.syncState = getBumpedSyncState(current.syncState);
    });
  });
};
